// Статус наявності, який конкурент показує біля ціни. «В наявності» —
// звичайний випадок, його не підписуємо; решту (напр. «Менше комплекту»,
// «Закінчується») показуємо поруч із ціною, щоб було видно, за яких умов
// ця ціна діє.
//
// Розкладка сторінок і кольори — у styles/theme.css (класи ui-*).
export const ORDINARY_AVAILABILITY = 'В наявності';

export const availabilityBadge = {
    display: 'block',
    marginTop: 2,
    fontSize: 11,
    fontWeight: 500,
    color: 'var(--warn)',
    whiteSpace: 'nowrap',
};
